import Api from '../../services/Api/Api';
import { PaymentCycle_BIMap } from '../../services/BiLogger/BiLoggerTypes';
import { AdvancedPlansProductData, ProductData } from '../../types';
import {
  Country,
  Experiments,
  PaymentCycle,
  ProductChangeType,
  UserColors,
} from 'enums';
import { AppProps } from './App';
import { STEP_ACTIONS } from 'stores/App.store';

export class AppController {
  constructor(private readonly props: AppProps) {
    const { appContext, setCouponCode } = this.props.rootStore.appStore;
    const { couponCode } = appContext.requestParamsMap;

    if (couponCode) {
      setCouponCode(couponCode);
    }

    if (this.isValidProductFromUrl()) {
      this.handelPreSelectedProduct();
    }
  }

  isValidProductFromUrl = () => {
    const {
      products,
      advancedPlansProducts,
      requestParamsMap,
    } = this.props.rootStore.appStore.appContext;
    const { productId } = requestParamsMap;
    return (
      !!productId &&
      (products.length === 1 || advancedPlansProducts.length === 1)
    );
  };

  handelPreSelectedProduct = () => {
    const {
      appContext,
      setCurrentCycle,
      setCurrentProduct,
      setStep,
      activateDirectChecktOut,
      isAnonymous,
    } = this.props.rootStore.appStore;
    const {
      siteGuid,
      requestParamsMap,
      isMobile,
      advancedPlansProducts,
    } = appContext;
    const { paymentCycle } = requestParamsMap;

    const product = advancedPlansProducts[0];
    setCurrentProduct(product);

    const canGoToStep1 = !isAnonymous && (!isMobile || !!siteGuid);
    let canGoToStep2 = !!siteGuid;
    if (canGoToStep1) {
      setStep(1);
      if (paymentCycle && PaymentCycle[paymentCycle]) {
        setCurrentCycle({
          cycle: PaymentCycle[paymentCycle],
        });
      } else {
        canGoToStep2 = false;
      }

      if (canGoToStep2) {
        activateDirectChecktOut();
      }
    }
  };

  onCycleSelect = () => {
    const { changeStep } = this.props.rootStore.appStore;

    if (this.shouldRedirectToOldCheckout()) {
      this.redirectToOldCheckout();
    } else {
      changeStep(STEP_ACTIONS.INCREMENT, () => {});
    }
  };

  onSelectProduct = async (product: ProductData | AdvancedPlansProductData) => {
    const {
      changeStep,
      setCurrentProduct,
      currentCycle,
      isChangePlan,
      openChangePlanModal,
      appContext,
    } = this.props.rootStore.appStore;
    setCurrentProduct(product);

    if (
      isChangePlan &&
      product.productChangeType === ProductChangeType.Downgrade
    ) {
      openChangePlanModal();
    } else {
      changeStep(STEP_ACTIONS.INCREMENT, (fromStep, toStep) =>
        appContext.biLogger.logSelectPlanBiEvent({
          ppType: product.type,
          cycle: PaymentCycle_BIMap[currentCycle],
          productId: product.id,
          productGuid: product.guid,
          referralAdditionalInfo: 'select-button',
        }),
      );
    }
  };

  shouldRedirectToOldCheckout() {
    const {
      country,
      userColors,
      experiments,
    } = this.props.rootStore.appStore.appContext;
    return (
      (country === Country.IN &&
        !experiments[Experiments.EnableIndiaOnNewCheckout]) ||
      userColors.regColor === UserColors.EDU
    );
  }

  redirectToOldCheckout = () => {
    const {
      appContext,
      currentCycle,
      currentProduct,
      removeUnloadListener,
    } = this.props.rootStore.appStore;
    const { siteGuid } = appContext;
    const { baseUrl } = this.props.rootStore.appStore;
    const directPurcahseUrl = `${baseUrl}store/plansPurchasePage`;

    removeUnloadListener && removeUnloadListener();
    window.location.assign(
      `${directPurcahseUrl}?siteGuid=${siteGuid}&productId=${currentProduct.id}&paymentCycle=${currentCycle}`,
    );
  };

  get fetchOrderPageFunction() {
    const { isDynamicOffering } = this.props.rootStore.appStore.appContext;

    return isDynamicOffering
      ? Api.fetchDynmicOrderPageData
      : Api.fetchOrderPageDataV2;
  }
}
